import script from "./ReviewPromptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewPromptModal.vue?vue&type=script&setup=true&lang=js"

import "./ReviewPromptModal.vue?vue&type=style&index=0&id=e0122a02&lang=css"

const __exports__ = script;

export default __exports__